import { fetcher } from "@weezevent/weezjs-core";

// GET ALL ZONES
export const getAllZones = ({ organizationId, eventId, params = {} }) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/zones`;
	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	};

	return fetcher.get(endpoint, options);
};

// DELETE ZONE
export const removeZone = ({ organizationId, eventId, id }) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/zones/${id}`;

	const options = {
		endpoint: window.weezConfig.api.apiUrl
	};

	return fetcher.delete(endpoint, {
		...options,
		cache: false
	});
};

// GET BY ONE ZONE
export const getZone = (organizationId, eventId, zoneId, params = {}) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/zones/${zoneId}`;
	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	};
	return fetcher.get(endpoint, options);
};

// CREATE A NEW ZONE
export const createZone = ({ organizationId, eventId, data }) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/zones`;

	const options = {
		data,
		endpoint: window.weezConfig.api.apiUrl
	};

	return fetcher.post(endpoint, {
		...options,
		cache: false
	});
};

// UPDATE ZONE
export const updateZone = ({ organizationId, eventId, id, data }) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/zones/${id}`;
	const options = {
		data,
		endpoint: window.weezConfig.api.apiUrl
	};

	return fetcher.patch(endpoint, {
		...options,
		cache: false
	});
};
